import React from 'react';
import { IQuestionProps } from '../../../../interface/multiCapabilityTemplate';
import { RadioOptionInfo } from '../radioOptionInfo';

const CheckboxQuestion = (props: IQuestionProps) => {
    return <RadioOptionInfo {...props} multiple />;
};
export { CheckboxQuestion };
